
import About from '../../components/About';
import ContactUs from '../../components/ContactUs';
// import Gallery from '../../components/Gallery';
import Home1 from '../../components/Home1';
import Services from '../../components/Services';
const Home = () => {

  return (
    <>
    <Home1/>

  
   
   
   


    <Services/>
    <About/>




    <ContactUs/>
    

    </>
  );
};

export default Home;
